import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_EXPORTS_MENU_ITEM,
  AFFILIATE_EXPORTS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
  AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
  DOWNLOAD_REPORT_PERMISSIONS,
  TRANSLATION_GROUP_ADMIN_DOWNLOAD_REPORT,
  TRANSLATION_GROUP_AFFILIATE_DOWNLOAD_REPORT,
  TRANSLATION_GROUP_DOWNLOAD_REPORT_BUTTON,
} from './constants';
import {
  getAdminDownloadReportTranslationKeys,
  getAffiliateDownloadReportTranslationKeys,
  getDownloadReportButtonTranslationKeys,
} from './translations';

export class DownloadReportModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      path: 'download-csv',
      permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
      component: () => import('./pages/DownloadReportListPage/DownloadReportListPage.vue'),
    });

    router.addAffiliateRoute({
      name: AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      path: 'download-csv',
      permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
      component: () => import('./pages/DownloadReportListPage/DownloadReportListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_EXPORTS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_EXPORT_DOWNLOAD_CSV'),
      to: {
        name: ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      },
      permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
      id: ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      order: 20,
    });

    menu.addChildAffiliateMenuItem(AFFILIATE_EXPORTS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'AFFILIATE_EXPORT_DOWNLOAD_CSV'),
      to: {
        name: AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      },
      permission: DOWNLOAD_REPORT_PERMISSIONS.SHOW,
      id: AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_DOWNLOAD_REPORT_BUTTON, getDownloadReportButtonTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_ADMIN_DOWNLOAD_REPORT, getAdminDownloadReportTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_DOWNLOAD_REPORT, getAffiliateDownloadReportTranslationKeys);
  }
}
